import { numberFormatterLocal } from '../../utils/formatters';

class ChipValueFormatterClass {
  private numberFormatCache: Record<string, Intl.NumberFormat> = {};
  private valueCache: Record<string, string> = {};

  format = (locale: string, value: number): string => {
    if (this.valueCache[`${locale}-${value}`]) {
      return this.valueCache[`${locale}-${value}`];
    }

    if (!this.numberFormatCache[locale]) {
      this.numberFormatCache[locale] = new Intl.NumberFormat(numberFormatterLocal(locale), {
        maximumFractionDigits: 3,
        minimumFractionDigits: 0,
      });
    }

    if (value < 10_000) {
      const modulo = value % 1;
      if (modulo === 0) {
        if (value > 999) {
          const N = value % 100;
          if (N === 0) {
            const valueToFormat = value / 1000;
            return this.numberFormatCache[locale].format(valueToFormat) + 'K';
          }
        }
      } else {
        let formattedValue = Math.floor(value);
        const stringValue = value.toString();
        if (value < 100) {
          if (stringValue.length > 5) {
            return this.numberFormatCache[locale].format(Number.parseFloat(stringValue.substring(0, 4))) + '+';
          }
        } else if (value >= 100 && value < 1000 && (modulo * 10) % 1 > 0) {
          if (stringValue.length > 5) {
            return this.numberFormatCache[locale].format(Number.parseFloat(stringValue.substring(0, 3))) + '+';
          }
        } else if (value >= 1000 && value < 10000) {
          formattedValue = Math.floor(value / 100) / 10;
          return this.numberFormatCache[locale].format(formattedValue) + 'K+';
        }
      }
    } else {
      const result = ~~(Math.log10(value) / 3);
      if (result > 0 && result < 5) {
        let postfix = 'KMBT'[result - 1] || '';

        const valueToFormat = value / Math.pow(1000, result);
        let formattedValue;
        let needPlus;
        if (valueToFormat > 99) {
          formattedValue = Math.floor(valueToFormat);
          needPlus = formattedValue < valueToFormat;
        } else if (valueToFormat < 10) {
          if ((valueToFormat * 100) % 1 === 0) {
            formattedValue = valueToFormat;
          } else {
            formattedValue = Math.floor(valueToFormat * 10) / 10;
            needPlus = formattedValue < valueToFormat;
          }
        } else {
          if ((valueToFormat * 10) % 1 === 0) {
            formattedValue = valueToFormat;
          } else {
            formattedValue = Math.floor(valueToFormat);
            needPlus = formattedValue < valueToFormat;
          }
        }

        postfix = postfix + (needPlus ? '+' : '');
        return this.numberFormatCache[locale].format(formattedValue) + postfix;
      }
    }
    const formattedValue = this.numberFormatCache[locale].format(value);
    this.valueCache[`${locale}-${value}`] = formattedValue;
    return formattedValue;
  };
}

export const ChipValueFormatter = new ChipValueFormatterClass();
